<script lang="ts" setup>
interface Props {
  hint?: string | null
}
defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <div :class="['leading-none', $attrs.class]">
    {{ hint || '&nbsp;' }}
  </div>
</template>
